<template>
  <div>
    <list
      row-key="MsgId"
      ref="list"
      unit="留言"
      :expand-all-row="true"
      :page="page"
      :show-checkbox="true"
      :query-params="params"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="姓名">
          <el-input size="mini" v-model="params.FullName" placeholder="请输入姓名" />
        </el-form-item>
        <el-form-item label="手机号码">
          <el-input size="mini" v-model="params.Mobile" placeholder="请输入手机号码" />
        </el-form-item>
        <el-form-item label="微信">
          <el-input size="mini" v-model="params.Wx" placeholder="请输入微信" />
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="FullName" label="姓名" :width="$store.state.isMB?'110px':''" />
        <el-table-column prop="Mobile" label="手机号码" width="160px" />
        <el-table-column prop="Wx" label="微信" />
        <el-table-column prop="Ip" label="IP地址" min-width="90px" />
        <el-table-column prop="AddTime" label="留言时间" min-width="90px" />
        <el-table-column prop="Content" label="内容" :min-width="$store.state.isMB?'150px':'250px'" show-overflow-tooltip />
      </template>
    </list>
  </div>
</template>
<script>
import list from "@/components/common/list";
import listMixin from "@/mixins/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/website/msg/msg").default,
      params: {
        FullName: "",
        Mobile: "",
        wx: ""
      },
    };
  },
  methods: {
  }
};
</script>